// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"88fa391e","85":"fd776c08","720":"e4ec649e","794":"3554a25a","954":"fc84d748"}[chunkId] + ".chunk.js";
};